// Breeze-9633 LLD: Message Socket utility methods
import io from "socket.io-client";

// default connection options
const defaultConnectOptions = {
    reconnection: true,
    autoConnect: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 2000,
    timeout: 3000,
};

// socket object
let socket = null;

// Utility method for connecting socket
export const connectSocket = (socketURL, connectOptions = defaultConnectOptions) => {
    if (!socket) {
        socket = io(socketURL, {
            transports: ['websocket'],
            ...connectOptions
        });
    }

    // returns a promise if socket created or error if socket not connected
    return new Promise((resolve, reject) => {
        socket.on('connect', () => {
            resolve(socket);
        });
        socket.on('connect_error', (error) => {
            reject(error);
        });
    });
}

// Utility method that adds an event listener for your socket by providing the event and callback
export const addSocketEventListener = (event, callback) => {
    if (socket) {
        socket.on(event, callback);
    }
}

// emit an event using the socket object
export const emitSocketEvent = (event, data, callback) => {
    if (socket) {
        socket.emit(event, data, callback);
    }
}

// disconnect socket
export const disconnectSocket = () => {
    if (socket) {
      socket.disconnect();
    }
}